import store from '~/store'

// este middleware é para a página de bloqueio por falta de pagamento
// obs: só pode ter acesso a esta página quem esta devendo
export default async (to, from, next) => {

  if (!store.getters['auth/check']) {
    next({ name: 'login' })
  } else {
        // Hoje
        let dataAtual = moment();
        //5 dias de tolerancia após do vencimento
        let dataBloqueio = moment(store.getters['auth/user'].venc_plano).add(5, 'days')

        if (dataAtual > dataBloqueio) {
            next()
        } else {
            next({ name: 'home' })
        }
  }

}



// WEBPACK FOOTER //
// ./resources/assets/js/middleware/venc_plano.js